export const classes = {
  list: 'px-1 py-4 bg-grey-1 min-w-[160px] dark:bg-white/[0.06]',
  listItem:
    'w-auto mx-3 py-1 pl-4 pr-10 rounded-lg hover:bg-grey-3 bg-grey-1 cursor-pointer dark:bg-transparent dark:hover:bg-white/[0.1]',
  text: 'select-none text-grey-8 dark:text-mauve-1',
};
